import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleTableComponent } from './components/simple-table/simple-table.component';
import { TableQueryService } from './service/table-query.service';
import { TableModule } from 'primeng/table';

@NgModule({
  imports: [CommonModule, TableModule],
  declarations: [SimpleTableComponent],
  providers: [TableQueryService],
  exports: [SimpleTableComponent],
})
export class SharedUiTablesModule {}
